import Base from './components/cells/Base';
import Avatar from './components/cells/Avatar';
import {
    createSyncPendingIndicator,
    shouldShowSyncPendingReviewIcon,
} from './components/syncListStatus/vanillaSyncPendingIcon';

/**
 * Same as `avatarCell`, plus optional sync-warning icon at the end when row sync status
 * is pending review (id 3). Expects `syncPendingReviewTooltip` in cellRendererParams (resolved literal).
 */
export default function AvatarCellWithSyncStatus() {}

AvatarCellWithSyncStatus.prototype.init = function (params) {
    const avatarNode = Avatar(params);
    let cellContent = avatarNode;

    if (params.showSyncStatus && shouldShowSyncPendingReviewIcon(params.data)) {
        const tooltipText = params.syncPendingReviewTooltip || '';
        const wrapper = document.createElement('div');
        wrapper.className = 'w5-avatar-cell-with-sync';

        const main = document.createElement('div');
        main.className = 'w5-avatar-cell-with-sync__main';
        main.appendChild(avatarNode);

        wrapper.appendChild(main);
        wrapper.appendChild(createSyncPendingIndicator({ tooltipText, agGridParams: params }));
        cellContent = wrapper;
    }

    this.eGui = Base(cellContent, params);
};

AvatarCellWithSyncStatus.prototype.getGui = function () {
    return this.eGui;
};
